import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Layout, Menu } from "antd";
import {
  SettingOutlined,
  InteractionOutlined,
  CodeSandboxOutlined,
} from "@ant-design/icons";
import {  QBO_APP_BASE_URL } from "../utils/constants";
import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";
 
import NavIcon from "../Components/Icon"

const { Sider } = Layout;
const fontSizeOfIcons = 14;



function SideBar() {
  const [isItemVisible, setIsItemVisible] = useState(false);
  const [companyDetails, setCompanyDetails] = useState({});
  const location = useLocation();
  const myArray = location.pathname.split("/");
  const compId = myArray[1];

  const state = useSelector(state => state);
  // console.log("State of redux in Navbar", state.companyReducer.company);
  
  useEffect(()=>{
    setCompanyDetails(state.companyReducer.company);
  },[state]);

 
  //  const companyId = params.companyId;

  const navbarVisibility = useSelector((state) => state.isNavbarVisibleReducer);
  const companyId =  state.companyReducer.company?.id;
  // console.log("CompanyId: ", companyId);
  useEffect(() => {
    setIsItemVisible(navbarVisibility);
  }, [navbarVisibility]);

  let navElements = [
    { name: "Manage", key: "1", to: "/" + compId, icon: CodeSandboxOutlined },
    {
      name: "Connection",
      key: "2",
      to: "/" + compId + "/ConnectionStatus",
      icon: InteractionOutlined,
    },

    {
      name: "Settings",
      key: "4",
      to: "/" + compId + "/settings",
      icon: SettingOutlined,
    },
  ];

  function disconnectQBO(e) {
    window.open(
      QBO_APP_BASE_URL + "/revoketoken.php?companyId=" + companyId,
      "_self"
    );
  }

  return (
    <div className="fixed h-screen">
      <Layout className="" style={{}}>
        <Sider
          width={240}
          breakpoint="lg"
          collapsedWidth="0"
          onBreakpoint={(broken) => {}}
          onCollapse={(collapsed, type) => {
            console.log(collapsed, type);
          }}
        >
          <div class="flex flex-col justify-center  h-screen bg-white border-r">
            {/* top icon */}
            <div class=" text-center    h-18 flex-none">
              <div className="pt-6">
                <img
                  alt="app icon"
                  className="h-8 w-40  ml-9 mr-9"
                  src={require("../images/navIcons/ignite_logo.png")}
                />
              </div>
            </div>

            {/* Menu Items */}
            <div class=" text-center     flex-1">
              <Menu
                style={{ marginTop: 60 }}
                theme="light"
                mode="inline"
                selectedKeys={[location.pathname]}
              >
                {isItemVisible == true &&
                  navElements.map((x) => {
                    return (
                      <Menu.Item
                        style={{ height: 41, fontSize: fontSizeOfIcons }}
                        key={x.to}
                        icon={
                          // <x.icon
                          //   style={{
                          //     marginLeft: 30,
                          //     fontSize: fontSizeOfIcons,
                          //   }}
                          // />
                          <NavIcon name={x.name} />

                        }
                      >
                        <NavLink to={x.to}>{x.name}</NavLink>
                      </Menu.Item>
                    );
                  })}
              </Menu>
            </div>

            {/* Lower portion */}
            <div className=" bg-nav_lower_bg w-full flex-none font-raleway">
              {companyDetails.shopify_shop_name ? <h1 className="text-xs text-center  text-white pt-4">
                {" "}
                Shopify -  {""}  {companyDetails.shopify_shop_name.split('.')[0]}
              </h1>: 
              <h1 className="text-xs text-center  text-white pt-4">
                Shopify -  {" Not connected "}
              </h1>
              }


              <div className=" flex justify-center mt-2">
                <img src={require("../images/icons/nav_sync_icon.png")} />
              </div>
              {companyDetails.qbo_company_name ? <h1 className="text-xs text-center  text-white mt-2.5">
                {" "}
                QuickBooks Online - {" "} {isItemVisible ? (companyDetails.qbo_company_name) : 'Not connected'}
              </h1> : <h1 className="text-xs text-center  text-white mt-2.5">
                {" "}
                QuickBooks Online -  
              </h1>}
              <div className="flex justify-center">

                {isItemVisible && <button
                  onClick={(e) => {
                    disconnectQBO(e);
                  }}
                  className="text-white border rounded-lg w-36 h-8 mt-4 mb-5 group"
                >
                  <div
                    className=" flex gap-2 justify-center align-middle pt-1   group-hover:bg-white group-hover:text-primary
                  group-hover:rounded-lg group-hover:w-36 group-hover:h-8"
                  >
                    <svg
                      width="26"
                      height="14"
                      viewBox="0 0 26 14"
                      fill="currentColor"
                      xmlns="http://www.w3.org/2000/svg"
                      className="mt-1"
                    >
                      <path
                        d="M9.37026 0.934788C6.24648 0.934788 3.67028 3.29286 3.31109 6.32072H0.7529C0.730359 6.31971 0.707817 6.31971 0.685524 6.32072C0.49492 6.32948 0.315844 6.41389 0.187358 6.55464C0.0591216 6.69565 -0.00800285 6.882 0.000762111 7.07235C0.00977841 7.26295 0.0939321 7.44203 0.234941 7.57052C0.37595 7.69875 0.562296 7.76588 0.752894 7.75686H3.31108C3.66523 10.79 6.24276 13.1428 9.37025 13.1428H10.4475C10.844 13.1428 11.1656 12.8212 11.1656 12.4247V10.9886H12.6017C12.794 10.9911 12.9794 10.9167 13.1161 10.7817C13.2531 10.6467 13.33 10.4626 13.33 10.2703C13.33 10.0782 13.2531 9.89383 13.1161 9.75883C12.9794 9.62408 12.794 9.54945 12.6017 9.5522H11.1656V4.52546H12.6017C12.794 4.52821 12.9794 4.45357 13.1161 4.31882C13.2531 4.18382 13.33 3.99948 13.33 3.80738C13.33 3.61502 13.2531 3.43093 13.1161 3.29593C12.9794 3.16093 12.794 3.08655 12.6017 3.08905H11.1656V1.65293C11.1656 1.25645 10.844 0.934872 10.4475 0.934872L9.37026 0.934788ZM15.4069 0.934788C15.2165 0.943555 15.0374 1.02796 14.9089 1.16872C14.7805 1.30973 14.7133 1.49607 14.7223 1.68642C14.7314 1.87702 14.8155 2.0561 14.9565 2.18459C15.0975 2.31282 15.2839 2.37995 15.4742 2.37093H16.5515C19.1497 2.37093 21.2193 4.44047 21.2193 7.03879C21.2193 9.63712 19.1498 11.7067 16.5515 11.7067H16.1923V4.52543C16.1951 4.33307 16.1207 4.14798 15.9857 4.01098C15.8507 3.87398 15.6666 3.79709 15.4742 3.79709C15.2821 3.79709 15.0978 3.87398 14.9628 4.01098C14.8278 4.14798 14.7534 4.33307 14.7562 4.52543V12.4248C14.7562 12.8213 15.0777 13.1428 15.4742 13.1428H16.5515C19.679 13.1428 22.2565 10.79 22.6106 7.75692H25.1688C25.3612 7.75967 25.5465 7.68529 25.6833 7.55028C25.8203 7.41528 25.8972 7.23119 25.8972 7.03884C25.8972 6.84649 25.8203 6.6624 25.6833 6.5274C25.5465 6.39239 25.3612 6.31801 25.1688 6.32076H22.6106C22.2515 3.29291 19.6752 0.934833 16.5515 0.934833H15.4742C15.4519 0.933832 15.4294 0.933832 15.4068 0.934833L15.4069 0.934788ZM9.37026 2.37091H9.72942V11.7065H9.37026C6.772 11.7065 4.70239 9.63697 4.70239 7.03865C4.70239 4.44032 6.77193 2.37078 9.37026 2.37078V2.37091Z"
                        fill="currentColor"
                      />
                    </svg>
                    <p className="text-sm ">Disconnect</p>
                  </div>
                </button>}


              </div>
            </div>
          </div>
        </Sider>
      </Layout>
    </div>
  );
}

export default SideBar;
